<template>
	<div class="slim-mainpanel">
		<div class="container">
			<div class="slim-pageheader">
				<ol class="breadcrumb slim-breadcrumb">
					<li class="breadcrumb-item"><a href="#">Operacional</a></li>
					<li class="breadcrumb-item"><a href="#">Importação</a></li>
					<li class="breadcrumb-item"><a href="#">Relatórios</a></li>
					<li class="breadcrumb-item active" aria-current="page">
						Declarações de Importação Registradas
					</li>
				</ol>
				<h6 class="slim-pagetitle">Declarações de Importação Registradas</h6>
			</div>

			<div class="bd bd-1 bd-b-0">
				<div class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5">
					<ul class="nav gap1">
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo">
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if=" filters.start !== '' && filters.end !== ''">
										<span class="mg-l-0 pd-l-0"> 
											<i class="fa fa-calendar tx-info mg-r-5"></i>Período:
											<span class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force">
												de {{ filters.start | moment("DD/MM/YYYY") }}
												até {{ filters.end | moment("DD/MM/YYYY") }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="fa fa-calendar mg-r-5"></i> Período:</span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										Data do Registro de DI
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Selecione a data inicial e final
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-6">
												<div class="form-group">
													<label class="form-control-label">
														Data Inicial <span class="tx-danger">*</span>
													</label>
													<date-picker
														lang="pt-br"
														v-model="filters.start"
														name="toPickedDate"
														format="DD/MM/YYYY"
														placeholder="Data Inicial"
													></date-picker>
												</div>
											</div>
											<div class="col-md-6 mg-t--1 mg-md-t-0">
												<div class="form-group mg-md-l--1">
													<label class="form-control-label">
														Data Final <span class="tx-danger">*</span>
													</label>
													<date-picker
														lang="pt-br"
														v-model="filters.end"
														name="toPickedDate"
														format="DD/MM/YYYY"
														placeholder="Data Final"
													></date-picker>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo ">
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if=" filters.federalIDImporter !== ''">
										<span class="mg-l-0 pd-l-0"> 
											<i class="icon ion-person-stalker tx-teal mg-r-5"></i>CNPJ do Importador:
											<span class="pd-x-5 badge badge-teal mg-b-0 mg-r-2-force tx-thin-force">
												{{ filters.federalIDImporter }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="icon ion-person-stalker tx-medium mg-r-5"></i> CNPJ do Importador: </span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										CNPJ do Importador
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Digite o CNPJ do Importador
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-control-label">
														CNPJ do Importador
													</label>
													<input type="tel" class="form-control" v-model="filters.federalIDImporter" v-mask="['##.###.###/####-##']">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo ">
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if=" filters.diNumber !== ''">
										<span class="mg-l-0 pd-l-0"> 
											<i class="fa fa-flag tx-warning mg-r-5"></i>Número da DI:
											<span class="pd-x-5 badge badge-warning mg-b-0 mg-r-2-force tx-thin-force">
												{{ filters.diNumber }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="fa fa-flag mg-r-5"></i> Número da DI: </span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										Número da DI
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Digite o número da DI
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-control-label">
														Número da DI
													</label>
													<input type="text" class="form-control" v-model="filters.diNumber" v-mask="'##/#######-#'">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo ">
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if=" filters.federalIDAcquirer !== ''">
										<span class="mg-l-0 pd-l-0"> 
											<i class="icon ion-person-stalker tx-indigo mg-r-5"></i>CNPJ do Adquirente:
											<span class="pd-x-5 badge badge-indigo mg-b-0 mg-r-2-force tx-thin-force">
												{{ filters.federalIDAcquirer }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="icon ion-person-stalker mg-r-5"></i> CNPJ do Adquirente: </span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
										CNPJ do Adquirente
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Digite o CNPJ do Adquirente
									</p>
									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-control-label">
														CNPJ do Adquirente
													</label>
													<input type="tel" class="form-control" v-model="filters.federalIDAcquirer" v-mask="['##.###.###/####-##']">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
						<li class="mg-t-5">
							<div class="dropdown dropdown-demo " data-pesistent>
								<a href="#" class="dd-link" data-toggle="dropdown">
									<div v-if="filters.reportOrganization?.label">
										<span class="mg-l-0 pd-l-0">
											<i class="fa fa-flag tx-danger mg-r-5"></i>Organização do Relatório:
											<span class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force">
												{{ filters.reportOrganization.label }}
											</span>
											<i class="fa fa-angle-down mg-l-5"></i>
										</span>
									</div>
									<div v-else>
										<span><i class="fa fa-flag mg-r-5"></i> Organização do Relatório: </span>
										<i class="fa fa-angle-down mg-l-5"></i>
									</div>
								</a>

								<div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
									<h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
										Organização do Relatório
									</h6>
									<p class="tx-gray-600 mg-b-10">
										Selecione uma Organização do Relatório ({{ this.listReportOrganization.length }} encontrados)
									</p>

									<div class="form-layout form-layout-2">
										<div class="row no-gutters">
											<div class="col-md-12">
												<div class="form-group">
													<label class="form-control-label"> Organização do Relatório </label>
													<v-select v-model="filters.reportOrganization" label="label" :options="listReportOrganization" name="reportOrganization">
														<template slot="option" slot-scope="option">
															{{ option.label }}
														</template>
													</v-select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
					<ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
						<li class="mg-l-10">
							<div class="btn-group gap1" role="group" aria-label="Ações">
								<button type="button" class="btn btn-primary pd-x-20 " @click.prevent="generateReport('tela')"> <i class="fa fa-file-code-o mg-r-5"></i> GERAR </button>
								<button type="button" class="btn btn-teal pd-x-20flex ai-c" @click.prevent="generateReport('excel')"> <i class="fa fa-file-excel-o mg-r-5"></i>  EXCEL </button>
							</div>
						</li>
					</ul>
				</div>

				<div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
					<div class="pd-10 mg-10">
						<div class="flex ai-c jc-sb fgap2">
							<div> 
								<label class="section-title mg-t-10 tx-16">Resultado da Consulta</label>
								<p class="mg-b-0">Foram encontrados {{ somaTotalDIs }} registros de acordo com o filtro acima.</p>
							</div>
						</div>
						<hr/>

						<template v-if="dis.length > 0 && filters.reportOrganization?.value === 'DI'">
							<div class="table-responsive">
								<table class="table table-striped mg-b-0">
									<thead>
										<tr>
											<th class="tx-center wd-150-force">Número</th>
											<th class="tx-center">URF Despacho</th>
											<th class="tx-center">Adições</th>
											<th class="tx-center">Importador / Adquirente</th>
											<th class="tx-center">Origem</th>
											<th class="tx-center">Registro</th>
											<th class="tx-center">Desembaraço</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="di in dis" :key="di._id">
											<th scope="row" class="tx-center wd-150-force">{{di._id | formatNumeroDI}}</th>
											<td><small>{{di.urfDespachoNome}}</small></td>
											<td class="tx-center">{{di.totalAdicoes}}</td>
											<td>
												<strong>{{di.importadorNumero}}</strong>
												<br />
												<small>{{di.importadorNome}}</small>
												<br />
												<template v-if="di.caracterizacaoOperacaoNome">
													<strong>{{di.caracterizacaoOperacaoNumero}}</strong>
													<br />
													<small>{{di.caracterizacaoOperacaoNome}}</small>
												</template>
												<template v-else>
													<small>{{di.caracterizacaoOperacaoDescricaoTipo}}</small>
												</template>
											</td>
											<td>{{di.cargaPaisProcedenciaNome}}</td>
											<td class="tx-center">{{di.dataRegistroDI | moment("DD/MM/YYYY") }}</td>
											<td class="tx-center">{{di.dataDesembaracoDI | moment("DD/MM/YYYY") }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</template>
						<template v-else-if="dis.length > 0">
							<table class="table table-striped mg-b-20 bd bd-1" v-for="di in dis" :key="di._id">
								<thead>
									<tr>
										<th class="tx-center wd-125">Número DI</th>
										<th>URF Despacho</th>
										<th>Importador / Adquirente</th>
										<th class="tx-center">Adições</th>
										<th>Origem</th>
										<th class="tx-center">Registro</th>
										<th class="tx-center">Desembaraço</th>
									</tr>
							</thead>
								<tbody>
									<tr :key="di._id">
										<td scope="row" class="tx-center wd-125">{{di._id | formatNumeroDI}}</td>
										<td><small>{{di.urfDespachoNome}}</small></td>
										<td>
											<strong>{{di.importadorNumero}}</strong>
											<br />
											<small>{{di.importadorNome}}</small>
											<br />
											<template v-if="di.caracterizacaoOperacaoNome">
												<strong>{{di.caracterizacaoOperacaoNumero}}</strong>
												<br />
												<small>{{di.caracterizacaoOperacaoNome}}</small>
											</template>
											<template v-else>
												<small>{{di.caracterizacaoOperacaoDescricaoTipo}}</small>
											</template>
										</td>

										<td class="tx-center">{{di.totalAdicoes}}</td>

										<td>{{di.cargaPaisProcedenciaNome}}</td>
									
										<td class="tx-center">{{di.dataRegistroDI | moment("DD/MM/YYYY") }}</td>
										<td class="tx-center">{{di.dataDesembaracoDI | moment("DD/MM/YYYY") }}</td>
									</tr>

									<tr :key="di._id+'-adicao'">
										<td colspan="7" class="pd-0 pd-t-0 pd-b-0">
											<label class="section-title">Adições - Declaração de Importação: {{di._id | formatNumeroDI}}</label>

											<table class="table bg-white bd bd-1">
												<tr>
													<th class="tx-center"></th>
													<th class="tx-center">Licença Importação</th>
													<th class="tx-center">NCM</th>
													<th class="tx-center">Incoterm</th>
													<th class="tx-center">Itens</th>
													<th class="tx-right">Frete</th>
													<th class="tx-right">Seguro</th>
													<th class="tx-right">II</th>
													<th class="tx-right">IPI</th>
													<th class="tx-right">PIS/PASEP</th>
													<th class="tx-right">COFINS</th>
												</tr>
											
												<tr v-for="adicao in di.adicao" :key="di._id+adicao.numeroAdicao" class="bg-white">
													<td class="tx-center">{{adicao.numeroAdicao}}</td>
													<td class="tx-center">{{adicao.numeroLI}}</td>
													<td class="tx-center">{{adicao.dadosMercadoriaCodigoNcm}}</td>
													<td class="tx-center">{{adicao.condicaoVendaIncoterm}}</td>
													<td class="tx-center">{{adicao.mercadoria.length}}</td>
													<td class="tx-right">{{adicao.seguroValorReais | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{adicao.freteValorReais | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{adicao.iiAliquotaValorRecolher | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{adicao.ipiAliquotaValorRecolher | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{adicao.pisPasepAliquotaValorRecolher | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
													<td class="tx-right">{{adicao.cofinsAliquotaValorRecolher | formatStringToDecimal | numeralFormat('0,0.00')}} </td>
												</tr>
											</table>
										</td>
									</tr>
								</tbody>
							</table>
							<br />
						</template>
						<template else>
							<div class="tx-center">Nenhum registro encontrado</div>
						</template>
					</div>
				</div>
			</div>
		</div>
  	</div>
</template>

<script>

import config from '@/config'
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal from "sweetalert2";
import Axios from "axios";
import { mask } from "vue-the-mask";

export default {
	name: "DIRegistered",
	props: [],
	components: {
		DatePicker,
	},
	directives: {
		mask,
	},
	data() {
		return { 
			results: {},
			dis: [],
			filters: {
				start: moment().startOf("month").toDate(),
				end: moment().endOf("month").toDate(),
				diNumber: '',
				federalIDImporter: '',
				federalIDAcquirer: '',
				reportOrganization: {label: 'Informações por DI', value: 'DI'},
			},
			listReportOrganization: [
				{
					label: "Informações por DI",
					value: "DI"
				},
				{
					label: "Informações por Adição",
					value: "ADICOES"
				}
			]
		};
	},
	methods: {
		keepOpen(event) {
			event.preventDefault();
			if (event.target && (event.target.tagName === 'A' || event.target.tagName === 'UL')) {
				const dropdowns = document.querySelectorAll('.dropdown-menu');
				dropdowns.forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			} 
		},
		async generateReport(type) {
			let filters = this.filters;
			this.dis = [];

			if (filters.start === "" || filters.end === "") {
				Swal.fire(
					"Declarações de Importação Registradas",
					"Você precisa selecionar um período para conseguir gerar o relatório.",
					"error"
				);
				return;
			}

			if (filters.federalIDImporter === "") {
				Swal.fire(
					"Declarações de Importação Registradas",
					"Você precisa adicionar o CNPJ do Importador para conseguir gerar o relatório.",
					"error"
				);
				return;
			}
		
			this.$store.commit("setLoading", {
				show: true,
				label: "Declarações de Importação Registradas",
				description: "Aguarde enquanto o relatório está sendo gerado...",
			});

			try {
				const data = {
					// Informações gerais
					nomeOperacao: "Relatório de DIs Registradas",
					...(filters.diNumber && { nrDeclaracao: filters.diNumber }),
					...(filters.federalIDImporter && { cnpjImportador: filters.federalIDImporter }),
					...(filters.federalIDAcquirer && { cnpjAdquirente: filters.federalIDAcquirer }),

					// Detalhes do relatório
					...(filters.reportOrganization?.value && { organizacaoDadosRelatorio: filters.reportOrganization.value }),

					// Período do relatório
					...(filters.start && { dataInicial: `${this.$moment(filters.start).format("Y-MM-DDT")}00:00:00` }),
					...(filters.end && { dataFinal: `${this.$moment(filters.end).format("Y-MM-DDT")}23:59:59` }),

					// Configurações do relatório
					...(type && { formato: type }),
				}

				let message = "Relatório gerado com sucesso!";

				if (type === 'excel') {
					const response = await Axios.post(`${config.env.API_DEFAULT.host}/integrations/myimp/relatorio-dis-excel`, data, { responseType: 'blob' });
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', `dis-registradas-${this.$moment(filters.start).format('DD-MM-YYYY')}-a-${this.$moment(filters.end).format('DD-MM-YYYY')}-${filters.reportOrganization.value}.xlsx`);
					document.body.appendChild(link);
					link.click();
				} else {
					const response = await Axios.post(`${config.env.API_DEFAULT.host}/integrations/myimp/relatorio-dis`, data);
					this.dis = response.data.data;
					message = `Foram encontrados ${this.dis.length} registros de acordo com o filtro.`;
				}

				Swal.fire(
					"Declarações de Importação Registradas",
					message,
					"success"
				);

				this.$store.commit("setLoading", { show: false });
			} catch (e) {
				console.log(e);
				Swal.fire(
					"Declarações de Importação Registradas",
					"Erro inesperado ao gerar o relatorio.",
					"error"
				);

				this.$store.commit("setLoading", { show: false });
			}
		}
	},
	filters: {
		formatNumeroDI: (value) => {    
			return value.substring(0, 2) + '/' + value.substring(2, 9) + '-' + value.substring(9, 10)
		},
		formatStringToDecimal: (value) => {    
			return parseFloat(value.substring(0, value.length - 2) + '.' + value.substring(value.length - 2, value.length));
		},
	},
	computed: {
		somaTotalDIs() {
			if ( this.dis !== null ) {
				return this.dis.length;
			} else {
				return 0;
			}
		},
	},
};
</script>

<style scoped>

.vs__selected-options span.selected-tag {
  margin: 5px 0px 0px -3px !important;
  padding: 5px !important;
}

.report-slim-pagetitle {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #343a40;

  border-left: 4px solid #4662d4;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #343a40;
  padding: 5px;
}

.report-box {
  max-width: 1100px;
  padding: 5px;
  margin: 20px;
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #343a40;
}

.report-box table {
  width: 100%;
}

.report-hr {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

.report-header {
  font-size: 12px;
}

.report-header-left {
  text-align: left;
  border-left: 6px solid #4662d4;
  padding-left: 5px;
}

.report-header-middle {
  padding-left: 20px;
  text-align: left !important;
  line-height: 20px;
}

.report-header-right {
  vertical-align: middle;
  line-height: 10px;
}

.report-header-right small {
  font-size: 10px;
}

.report-list {
  width: 100%;
  border-collapse: collapse;
}

.report-list th {
  text-transform: uppercase;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-list td {
  font-size: 11px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-footer {
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  line-height: 8px;
}

.report-footer small {
  font-size: 9px;
}

.report-tx-center {
  text-align: center;
}

.report-tx-bold {
  font-weight: bold;
}

.report-tx-10 {
  font-size: 10px;
}

.columns-list {
  max-height: calc(100vh - 250px);
  overflow: auto;
  border: 1px solid #e2e2e2;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: white;
}

.columns-list li {
  padding: 0.35rem 0.75rem;
  border-radius: 2px;
  font-weight: 500;
}

.columns-list.active li {
  border-color: #106dc4;
  color: #106dc4;
  background-color: rgba(16, 109, 196, 0.1);
}

.columns-list.active li:hover {
  background-color: #106dc4;
  color: white;
}

.columns-list li:hover {
  cursor: pointer;
}

.columns-list .list-group-item.active {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
